module.exports = __webpack_public_path__ + "static/media/Character6.47eefa88.png";